import { atom } from "recoil";

export const modalState = atom({
    key: "recoil-modal-state",
    default: true,
});
